import { ActionTree } from 'vuex';
import ApiUrl from '../../../api/url';
import { CsvListState } from './types';
import { RootState } from '../../types';
import * as types from './mutation-types';
import { isHappenedOtherPartyError } from '../../error-type';
import router from '../../../router/index';
import { AppContext } from '../../context';
const MessageKey = AppContext.MessageKey;
import { translator } from '../../translator';
import ScreenUrl from '../../../router/url';

export const actions: ActionTree<CsvListState, RootState> = {
    /**
     * CSVファイル一覧検索
     * @param {any} dispatch Vuex変数
     * @param {any} commit Vuex変数
     * @param {any} pageNumber ページ番号
     * @param {any} perPage ページ毎の表示件数
     * @param {any} sort ソートするカラムと順番
     * @returns {Promise<void>}
     */
    async search({ dispatch, commit }, { pageNumber, perPage, sort } = {}) {
        const payload = {
            page_number: pageNumber,
            per_page: perPage,
            'sort[column]': sort.column,
            'sort[direction]': sort.direction,
        };
        try {
            commit(types.SEARCH_START);
            const resData = await dispatch(
                'auth/api',
                { method: 'get', url: ApiUrl.CsvList.SEARCH, params: payload },
                { root: true }
            );
            if (isHappenedOtherPartyError(resData)) {
                // システムエラー・予期せぬエラー時
                commit(types.FATAL_FAILURE);
            } else {
                // 成功時
                commit(types.SEARCH_SUCCESS, resData);
            }
        } catch (resData) {
            // アプリケーションエラー時
            commit(types.SEARCH_FAILURE, resData.errors[0]);
        }
    },

    /**
     * CSVファイルダウンロード処理開始
     * @param {any} commit Vuex変数
     * @returns {Promise<void>}
     */
    async downloadStart({ commit }) {
        commit(types.CSV_DOWNLOAD_START);
    },

    /**
     * CSVファイルダウンロード処理正常終了
     * @param {any} commit Vuex変数
     * @returns {Promise<void>}
     */
    async downloadSuccess({ commit }) {
        commit(types.CSV_DOWNLOAD_SUCCESS);
    },

    /**
     * CSVファイルダウンロード処理エラー終了
     * @param {any} commit Vuex変数
     * @param resData エラーレスポンス
     * @returns {Promise<void>}
     */
    async downloadFailure({ commit }, resData) {
        const params = {
            errorTitle: resData.title,
            errorDetails: resData.errors,
        };
        commit(types.CSV_DOWNLOAD_FAILURE, params);
    },

    /**
     * 画面切り替え時のstoreの消去
     * @param {any} commit Vuex変数
     * @returns {Promise<void>}
     */
    async clearOnBeforeRoute({ commit }) {
        commit(types.CLEAR_ALL);
    },
};
